var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsnew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.575,
    height: 57.5,
    viewBox: "0 0 43.575 57.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2946",
    "data-name": "Group 2946",
    transform: "translate(-291 -756.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1420",
    "data-name": "Group 1420",
    transform: "translate(298.782 756.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85363",
    "data-name": "Path 85363",
    d: "M3316.611,3048.091s-5.867-5.333-3.467-12.266,9.6-5.6,9.6-5.6,7.732.8,8.266,8.533-5.333,9.333-5.333,9.333l1.067,2.933h-10.132Z",
    transform: "translate(-3304.31 -3022.897)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M279.542,107.252A10.73,10.73,0,0,0,280.8,90.957,10.146,10.146,0,0,0,273.485,88a10.5,10.5,0,0,0-10.189,10.6,10.665,10.665,0,0,0,4.431,8.659.556.556,0,0,1,.221.456v1.38a3.1,3.1,0,0,0,.517,5.608v1.211a3.1,3.1,0,0,0,3.1,3.1H275.7a3.1,3.1,0,0,0,3.1-3.1V114.7a3.1,3.1,0,0,0,.517-5.608v-1.379A.557.557,0,0,1,279.542,107.252ZM265.364,98.59a8.425,8.425,0,0,1,8.152-8.524h.118a8.1,8.1,0,0,1,5.72,2.365,8.663,8.663,0,0,1-1.013,13.139,2.629,2.629,0,0,0-1.09,2.14v.962h-7.236v-.963a2.625,2.625,0,0,0-1.088-2.138A8.593,8.593,0,0,1,265.364,98.59ZM275.7,116.941h-4.135a1.035,1.035,0,0,1-1.034-1.034v-1.034h6.2v1.034A1.035,1.035,0,0,1,275.7,116.941Zm2.067-4.135H269.5a1.034,1.034,0,0,1,0-2.067h8.27a1.034,1.034,0,1,1,0,2.067Z",
    transform: "translate(-256.151 -81.796)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M351.937,125.126a4.673,4.673,0,0,1,2.693,3.052,1.034,1.034,0,1,0,1.99-.56,6.756,6.756,0,0,0-3.9-4.406,1.034,1.034,0,0,0-.783,1.913Z",
    transform: "translate(-332.779 -112.393)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M337.367,43.1V41.034a1.034,1.034,0,0,0-2.067,0V43.1a1.034,1.034,0,0,0,2.067,0Z",
    transform: "translate(-318.851 -40)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M285.106,55.02a1.034,1.034,0,0,0,.943-1.454l-.841-1.889a1.034,1.034,0,0,0-1.889.841l.841,1.889A1.034,1.034,0,0,0,285.106,55.02Z",
    transform: "translate(-273.51 -49.634)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M242.744,85.8a1.034,1.034,0,0,0,.692-1.8L241.9,82.617a1.034,1.034,0,1,0-1.383,1.537l1.536,1.383A1.03,1.03,0,0,0,242.744,85.8Z",
    transform: "translate(-236.017 -76.879)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M217.545,130.436a1.034,1.034,0,0,0-.664-1.3l-1.966-.639a1.034,1.034,0,1,0-.639,1.966l1.966.639a1.032,1.032,0,0,0,1.3-.664Z",
    transform: "translate(-212.843 -117.016)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M210.981,179.712l-2.056.216a1.034,1.034,0,0,0,.216,2.056l2.056-.216a1.034,1.034,0,0,0-.216-2.056Z",
    transform: "translate(-207.999 -161.655)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M447.61,181.768l2.056.216a1.034,1.034,0,1,0,.216-2.056l-2.056-.216a1.034,1.034,0,1,0-.216,2.056Z",
    transform: "translate(-415.844 -161.655)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M442.844,131.151a1.031,1.031,0,0,0,.32-.051l1.966-.639a1.034,1.034,0,0,0-.639-1.966l-1.966.639a1.034,1.034,0,0,0,.319,2.017Z",
    transform: "translate(-411.599 -117.016)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M420.257,85.538l1.536-1.383a1.034,1.034,0,1,0-1.383-1.536L418.873,84a1.034,1.034,0,1,0,1.383,1.536Z",
    transform: "translate(-391.328 -76.881)",
    fill: "#0094d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M381.888,55.02a1.034,1.034,0,0,0,.945-.613l.841-1.889a1.034,1.034,0,0,0-1.889-.841l-.841,1.889a1.034,1.034,0,0,0,.943,1.454Z",
    transform: "translate(-358.52 -49.634)",
    fill: "#0094d9"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M51.551,345.9l-8.629,4.273a3.792,3.792,0,0,0-2.61-2.759l-4-1.184c-2.88-.856-6.671-1.56-10.449.618-.24.137-.454.275-.644.4a3.665,3.665,0,0,1-2.412.748A2.713,2.713,0,0,0,20.3,346.3H16.209a2.711,2.711,0,0,0-2.709,2.708v9.5a2.711,2.711,0,0,0,2.709,2.708H20.3a2.711,2.711,0,0,0,2.7-2.531,16.232,16.232,0,0,1,5.107.828c1.265.373,6.673,1.946,7.085,2.065a13.351,13.351,0,0,0,3.692.725,8.1,8.1,0,0,0,4.6-1.654l.026-.018,11.881-8.455a3.679,3.679,0,0,0-3.843-6.272ZM20.983,358.5a.68.68,0,0,1-.68.679H16.209a.681.681,0,0,1-.68-.679v-9.5a.68.68,0,0,1,.68-.679H20.3a.68.68,0,0,1,.68.679v9.5Zm33.235-7.985-11.869,8.446c-2.691,1.79-3.833,1.459-6.587.66-.417-.121-5.813-1.691-7.077-2.063a18,18,0,0,0-5.673-.909v-6.635a5.59,5.59,0,0,0,3.308-1.066c.178-.114.362-.232.56-.346,2.459-1.418,5.109-1.548,8.86-.432l4,1.184a1.755,1.755,0,0,1,1.191,2.165v0a1.753,1.753,0,0,1-2.17,1.182l-5.714-1.656A1.014,1.014,0,0,0,32.477,353l5.714,1.656a3.788,3.788,0,0,0,4.522-2.119l9.737-4.823a1.784,1.784,0,0,1,2.36.494A1.727,1.727,0,0,1,54.218,350.518Z",
    transform: "translate(277.5 451.979)",
    fill: "#0094d9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsnew);
export default __webpack_public_path__ + "static/media/whatsnew.fda9510cf493b54344de8c0b6c397a12.svg";
export { ForwardRef as ReactComponent };